import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c5a1ad34&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c5a1ad34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a1ad34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mychefkoo/Documents/cloud-dom/cloud-web/erp-flexible-web21/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5a1ad34')) {
      api.createRecord('c5a1ad34', component.options)
    } else {
      api.reload('c5a1ad34', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c5a1ad34&scoped=true&", function () {
      api.rerender('c5a1ad34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/radioTable/index.vue"
export default component.exports